import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemeListesiv2DetayTedarikci_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemeListesiv2DetayTedarikci_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  YuklemePlan_Get_MasterById: any[];
  YuklemePlan_Get_MasterById_dummy: any[];
  YuklemePlan_Get_TedarikciDetailsByMasterId: any[];
  YuklemePlan_Get_TedarikciDetailsByMasterId_dummy: any[];
  isComp730851Visible: "visible" | "hidden";
  isComp539252Enabled: "enabled" | "disabled";
  isComp497930Enabled: "enabled" | "disabled";
  isComp321405Enabled: "enabled" | "disabled";
  isComp799315Enabled: "enabled" | "disabled";
  isComp370124Enabled: "enabled" | "disabled";
  isComp345115Enabled: "enabled" | "disabled";
  isComp359094Enabled: "enabled" | "disabled";
  isComp557640Enabled: "enabled" | "disabled";
}

export class YuklemeListesiv2DetayTedarikci_ScreenBase extends React.PureComponent<
  IYuklemeListesiv2DetayTedarikci_ScreenProps,
  any
> {
  yuklemelistesiv2detaytedarikci_359094_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2detaytedarikci_559033_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "78e657ef-da1e-412e-9901-b50715f7f064",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 980166,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        { Id: 162294, PropertyName: "value", Value: "YÜKLEME EMRİ DETAYLARI" },
        { Id: 755618, PropertyName: "value", Value: "Yükleme No" },
        { Id: 539252, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 500625, PropertyName: "value", Value: "Taşıyıcı Firma" },
        { Id: 497930, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 916633, PropertyName: "value", Value: "Plaka" },
        { Id: 321405, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 323894, PropertyName: "value", Value: "Araç Tipi" },
        { Id: 799315, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 317819, PropertyName: "value", Value: "Sürücü Adı" },
        { Id: 370124, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 917526, PropertyName: "value", Value: "Sürücü Gsm" },
        { Id: 345115, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 73245, PropertyName: "value", Value: "Planlanan Yükleme Tarihi" },
        { Id: 359094, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 527146, PropertyName: "value", Value: "Toplam Ağırlık" },
        { Id: 557640, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 408516, PropertyName: "title", Value: "TeslimatNo" },
        { Id: 307294, PropertyName: "value", Value: "[datafield:teslimatno]" },
        { Id: 42704, PropertyName: "title", Value: "Müşteri" },
        { Id: 730621, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 619123, PropertyName: "title", Value: "Cikis Yeri" },
        {
          Id: 924550,
          PropertyName: "value",
          Value: "[datafield:cikisnoktaadi]",
        },
        { Id: 768361, PropertyName: "title", Value: "Varış Yeri" },
        {
          Id: 804461,
          PropertyName: "value",
          Value: "[datafield:varisnoktaadi]",
        },
        { Id: 997454, PropertyName: "title", Value: "Palet Sayisi" },
        {
          Id: 434788,
          PropertyName: "value",
          Value: "[datafield:toplampaletsayisi]",
        },
        { Id: 440379, PropertyName: "title", Value: "Ağırlık" },
        {
          Id: 14457,
          PropertyName: "value",
          Value: "[datafield:toplamagirlik]",
        },
        { Id: 632723, PropertyName: "title", Value: "İl" },
        { Id: 189182, PropertyName: "value", Value: "[datafield:sehiradi]" },
        { Id: 93502, PropertyName: "title", Value: "İlçe" },
        { Id: 506306, PropertyName: "value", Value: "[datafield:ilceadi]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemelistesiv2detaytedarikci_539252_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_497930_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_321405_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_799315_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_370124_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_345115_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_359094_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_557640_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2detaytedarikci_559033_value_kuikaTableRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      YuklemePlan_Get_MasterById: [],
      YuklemePlan_Get_TedarikciDetailsByMasterId: [],
      isComp730851Visible: "hidden",
      isComp539252Enabled: "disabled",
      isComp497930Enabled: "disabled",
      isComp321405Enabled: "disabled",
      isComp799315Enabled: "disabled",
      isComp370124Enabled: "disabled",
      isComp345115Enabled: "disabled",
      isComp359094Enabled: "disabled",
      isComp557640Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "yuklemelistesiv2detaytedarikci",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemeListesiv2DetayTedarikciPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2detaytedarikci",
      ""
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2detaytedarikci",
      ""
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemeListesiv2DetayTedarikciPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemelistesiv2detaytedarikci_539252_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.yuklemeNo ?? undefined,
      yuklemelistesiv2detaytedarikci_497930_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.tasiyiciFirmaAdi ??
        undefined,
      yuklemelistesiv2detaytedarikci_321405_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.plaka ?? undefined,
      yuklemelistesiv2detaytedarikci_799315_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.aracTipi ?? undefined,
      yuklemelistesiv2detaytedarikci_370124_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.surucuAdi ?? undefined,
      yuklemelistesiv2detaytedarikci_345115_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.surucuGSM ?? undefined,
      yuklemelistesiv2detaytedarikci_359094_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)
          ?.planlananYuklemeTarihi ?? undefined,
      yuklemelistesiv2detaytedarikci_557640_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.brutAgirlilk ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemeListesiv2DetayTedarikciPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2DetayTedarikciPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2DetayTedarikciPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2DetayTedarikci/YuklemeListesiv2DetayTedarikciPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.YuklemePlan_Get_MasterById =
      result?.data.yuklemePlan_Get_MasterById;
    formVars.yuklemelistesiv2detaytedarikci_539252_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
          : null
      );
    formVars.yuklemelistesiv2detaytedarikci_497930_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirmaAdi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirmaAdi
          : null
      );
    formVars.yuklemelistesiv2detaytedarikci_321405_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].plaka
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].plaka
          : null
      );
    formVars.yuklemelistesiv2detaytedarikci_799315_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );
    formVars.yuklemelistesiv2detaytedarikci_370124_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuAdi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuAdi
          : null
      );
    formVars.yuklemelistesiv2detaytedarikci_345115_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuGSM
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuGSM
          : null
      );
    formVars.yuklemelistesiv2detaytedarikci_359094_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
      );
    formVars.yuklemelistesiv2detaytedarikci_557640_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].brutAgirlilk
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].brutAgirlilk
          : null
      );
    stateVars.YuklemePlan_Get_TedarikciDetailsByMasterId =
      result?.data.yuklemePlan_Get_TedarikciDetailsByMasterId;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2DetayTedarikciPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2DetayTedarikciPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemelistesiv2detaytedarikci_539252_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
          : null
      );

    formVars.yuklemelistesiv2detaytedarikci_497930_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirmaAdi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirmaAdi
          : null
      );

    formVars.yuklemelistesiv2detaytedarikci_321405_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].plaka
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].plaka
          : null
      );

    formVars.yuklemelistesiv2detaytedarikci_799315_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );

    formVars.yuklemelistesiv2detaytedarikci_370124_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuAdi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuAdi
          : null
      );

    formVars.yuklemelistesiv2detaytedarikci_345115_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].surucuGSM
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].surucuGSM
          : null
      );

    formVars.yuklemelistesiv2detaytedarikci_359094_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
      );

    formVars.yuklemelistesiv2detaytedarikci_557640_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].brutAgirlilk
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].brutAgirlilk
          : null
      );

    stateVars.dataSource_559033 =
      stateVars.YuklemePlan_Get_TedarikciDetailsByMasterId ??
      this.state.YuklemePlan_Get_TedarikciDetailsByMasterId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2DetayTedarikciComponent_491786_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeListesiv2DetayTedarikciComponent_491786_onClick1_,
        "YuklemeListesiv2DetayTedarikci",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "29182",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2DetayTedarikciComponent_491786_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeListesiv2DetayTedarikciComponent_491786_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "YuklemeListesiv2DetayTedarikci",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "981687",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [29182, 981687] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemeListesiv2DetayTedarikciPageInit();
    }
    if (diId == 29182) {
      isErrorOccurred =
        await this.YuklemeListesiv2DetayTedarikciComponent_491786_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
